var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "articleModal",
          attrs: {
            visible: _vm.visible,
            title: "产品信息设置",
            top: "100px",
            width: "600px",
            "destroy-on-close": "",
            modal: false,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "pram", attrs: { "label-width": "90px", model: _vm.pram } },
            [
              _c("el-form-item", { attrs: { label: "SKU编号：" } }, [
                _c("div", [_vm._v(_vm._s(_vm.details.skuCode))]),
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "SKU名称：" } }, [
                _c("div", [_vm._v(_vm._s(_vm.details.skuName))]),
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "价格形式：" } },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { size: "small" },
                      model: {
                        value: _vm.pram.priceType,
                        callback: function ($$v) {
                          _vm.$set(_vm.pram, "priceType", $$v)
                        },
                        expression: "pram.priceType",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: 1 } }, [_vm._v("价格")]),
                      _vm._v(" "),
                      _c("el-radio", { attrs: { label: 2 } }, [_vm._v("折扣")]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "对应数值：" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0, placeholder: "请输入对应数值" },
                    model: {
                      value: _vm.pram.corrAmount,
                      callback: function ($$v) {
                        _vm.$set(_vm.pram, "corrAmount", $$v)
                      },
                      expression: "pram.corrAmount",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "附属参数：", prop: "interfaceTemplate" } },
                [
                  _vm.nameList && _vm.nameList.length
                    ? _vm._l(_vm.nameList, function (name, i) {
                        return _c(
                          "div",
                          { key: i, staticClass: "flex" },
                          [
                            _c("el-input", {
                              attrs: { disabled: true, placeholder: "参数名" },
                              model: {
                                value: _vm.nameList[i].key,
                                callback: function ($$v) {
                                  _vm.$set(_vm.nameList[i], "key", $$v)
                                },
                                expression: "nameList[i].key",
                              },
                            }),
                            _vm._v(" "),
                            _c("span", [_vm._v("：")]),
                            _vm._v(" "),
                            _c("el-input", {
                              attrs: { placeholder: "参数值" },
                              model: {
                                value: _vm.nameList[i].value,
                                callback: function ($$v) {
                                  _vm.$set(_vm.nameList[i], "value", $$v)
                                },
                                expression: "nameList[i].value",
                              },
                            }),
                          ],
                          1
                        )
                      })
                    : _c("span", [_vm._v("无需设置")]),
                ],
                2
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.loading },
                  on: {
                    click: function ($event) {
                      return _vm.handerSubmit("pram")
                    },
                  },
                },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "link" }, on: { click: _vm.closeEdit } },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }